// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"2be25c0e","325":"ff1c628e","355":"4222cda8","453":"091a0454","455":"56248ac3","498":"a3f7f3c0","644":"ef13e52e"}[chunkId] + ".chunk.js";
};